import { pdf } from "@react-pdf/renderer";
import { PayslipPDF } from "./PayslipPDF";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { fetchPayslipById } from "../payslipsSlice";
import getLocale from "../../../../common/helpers/getLocale";
import { isFulfilled } from "@reduxjs/toolkit";
import DownloadIcon from "@mui/icons-material/Download";
import theme from "../../../../theme";
import { downloadBlob } from "../../../../common/helpers/downloadBlob";
import { Box, CircularProgress } from "@mui/material";

type Props = {
  payslipId: string;
};

export const ExportPayslipPDF = ({ payslipId }: Props) => {
  const dispatch = useAppDispatch();
  const languageCode = getLocale().code;
  const localizedExpenseTypes = useAppSelector(
    (state) => state.localized?.expenseType,
  );

  const [isLoading, setIsLoading] = useState(false);

  const downloadPdf = (payslipId: string) => {
    if (!payslipId) return;
    setIsLoading(true);
    // Fetch payslip data
    dispatch(fetchPayslipById({ id: payslipId, languageCode })).then(
      async (action) => {
        if (isFulfilled(action)) {
          const payslip = action.payload;
          // Generate PDF and convert to blob
          const blob = await pdf(
            <PayslipPDF
              payslip={payslip}
              localizedExpenseTypes={localizedExpenseTypes}
            />,
          ).toBlob();

          downloadBlob(
            blob,
            `${payslip.recipient.name} ${payslip.salaryDate}.pdf`,
          );
        }
        setIsLoading(false);
      },
    );
  };

  return (
    <>
      {!isLoading ? (
        <DownloadIcon
          onClick={() => {
            downloadPdf(payslipId);
          }}
          sx={{
            width: 20,
            height: 20,
            marginTop: "2px",
            cursor: "pointer",
            color: theme.palette.primary.main,
            ":hover": {
              color: theme.palette.primary.light,
            },
          }}
        />
      ) : (
        <Box>
          <CircularProgress size={16} sx={{ marginTop: "2px" }} />
        </Box>
      )}
    </>
  );
};
